// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qe0W","badges":"styles_badges__2r0ws"};